import styled, { css } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { ThemeMode } from '@/helpers/enums';
import type { InputStructureProps } from './InputStructure';

const successIcon = getCDNImageUrl('/icon-img/tickCircleIcon.svg');
const errorIcon = getCDNImageUrl('/icon-img/tickCircleDeclineIcon.svg');

export const ScInputStructure = styled.div<
  Pick<InputStructureProps, 'mode' | 'hideErrorBorder' | 'isHidden'>
>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ isHidden }) =>
    isHidden &&
    css`
      opacity: 0;
      position: absolute;
      pointer-events: none;
      width: 0;
      height: 0;
    `}

  & input::placeholder {
    color: ${({ theme }) => theme.blackLightColor};
  }

  .content {
    position: relative;

    .addons {
      position: absolute;
      height: 100%;
      top: 0;
      right: 4px;
      display: flex;
      align-items: center;
      gap: 4px;
      

      & > .icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
        &.error-icon {
          background: ${() => `url(${errorIcon}) center no-repeat`};
        }
        &.success-icon {
          background: ${() => `url(${successIcon}) center no-repeat`};
        }
      }
    }
  }

  & > .info,
  & > .error,
  & .content > .error {
    font-size: 12px;
    line-height: 18px;
    padding: 0 16px;
    position: relative;
  }

  & > .info {
    color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
  }

  & .content > .error,
  & > .error {
    color: ${({ theme }) => theme.redColor};
  }
`;
